import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

const stats = [
  { value: "+10", label: "Años de trayectoria" },
  { value: "100%", label: "Habilitaciones vigentes" },
  { value: "24/7", label: "Disponibilidad operativa" },
  { value: "PBA", label: "Cobertura provincial" },
];

const bullets = [
  "Rigurosidad técnica que exige la industria",
  "Agilidad que necesita el vecino en su hogar",
  "Transparencia operativa y trazabilidad documental",
  "Flota propia y red de plantas habilitadas",
];

export default function About() {
  return (
    <section
      id="nosotros"
      data-testid="about-section"
      className="bg-bone relative py-20 md:py-28"
    >
      <div className="max-w-[1500px] mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <motion.div
            initial={{ opacity: 0, x: -24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-6 relative"
          >
            <div className="relative">
              <img
                src="/assets/ops1.jpg"
                alt="Camión Royal Eco en operación de descarga en planta habilitada"
                className="w-full h-[420px] md:h-[560px] object-cover"
                loading="lazy"
              />
            </div>

            <div className="absolute -bottom-8 right-0 md:-right-4 bg-asphalt text-bone p-5 max-w-[260px] hidden md:block">
              <div className="tag text-lime-400 mb-2">Flota propia</div>
              <div className="font-display text-2xl leading-tight">
                Scania, Iveco y equipos especializados
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="lg:col-span-6"
          >
            <div className="tag text-forest-600 mb-5 lime-rule">
              Nosotros
            </div>
            <h2 className="font-display text-5xl sm:text-6xl md:text-7xl text-asphalt leading-[0.92]">
              Unimos la rigurosidad
              <br />
              <span className="text-forest-700">con la agilidad.</span>
            </h2>
            <p className="mt-8 text-forest-600 text-lg leading-relaxed max-w-xl">
              Somos una empresa con una trayectoria sólida de más de una
              década en el mercado, nacida con el objetivo de unir la
              rigurosidad técnica que exige la industria con la agilidad
              que necesita el vecino en su hogar.
            </p>

            <ul className="mt-8 space-y-3">
              {bullets.map((b) => (
                <li
                  key={b}
                  className="flex items-start gap-3 text-asphalt"
                  data-testid="about-bullet"
                >
                  <CheckCircle2 className="w-5 h-5 text-lime-500 shrink-0 mt-0.5" />
                  <span className="font-medium">{b}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>

        {/* Stats strip */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-20 grid grid-cols-2 lg:grid-cols-4 border-y-2 border-asphalt"
        >
          {stats.map((s, i) => (
            <div
              key={s.label}
              data-testid={`about-stat-${i}`}
              className={`p-8 md:p-10 ${
                i < 3 ? "lg:border-r border-asphalt/15" : ""
              } ${i === 1 ? "lg:border-r-2" : ""} ${
                i % 2 === 0 ? "border-r border-asphalt/15" : ""
              } ${i >= 2 ? "border-t border-asphalt/15 lg:border-t-0" : ""}`}
            >
              <div className="stat-num text-asphalt">{s.value}</div>
              <div className="mt-3 tag text-forest-600">{s.label}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
